import { render, staticRenderFns } from "./PortalsCard.vue?vue&type=template&id=9c0bb4a6&scoped=true"
import script from "./PortalsCard.vue?vue&type=script&lang=js"
export * from "./PortalsCard.vue?vue&type=script&lang=js"
import style0 from "./PortalsCard.vue?vue&type=style&index=0&id=9c0bb4a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c0bb4a6",
  null
  
)

export default component.exports